<template>
  <bulk-create-modal
    ref="bulkEditModalRef"
    :title="capitalizeTranslation('messages.importViews')"
    :model-parser="userViewBulkCreateParser"
    :allow-to-download-template="false" />
</template>

<script setup lang="ts">
  import { computed, ref, useTemplateRef } from 'vue';
  import { ComponentExposed } from 'vue-component-type-helpers';

  import BulkCreateModal from '@/common/components/controls/table/bulk-create/BulkCreateModal.vue';
  import { ITableFilter } from '@/common/components/controls/table/TableFilter';
  import TableSettings from '@/common/components/controls/table/TableUserSettings/TableSettings';
  import UserView from '@/common/components/controls/table/TableUserSettings/UserView';
  import SpreadSheetUserViewParser from '@/common/components/controls/table/user-views/UserViewParser';
  import { capitalizeTranslation } from '@/globals';

  interface IProps {
    tableSettings: TableSettings;
    availableFilters: ITableFilter[];
  }

  const { tableSettings, availableFilters } = defineProps<IProps>();

  const userViewBulkCreateParser = ref<SpreadSheetUserViewParser>();
  const bulkEditModalRef = useTemplateRef<ComponentExposed<typeof BulkCreateModal>>('bulkEditModalRef');

  const views = computed<UserView[]>(() => tableSettings?.userViews || []);

  function open() {
    initParser();
    bulkEditModalRef.value.open();
  }

  function initParser() {
    userViewBulkCreateParser.value = new SpreadSheetUserViewParser(views.value, availableFilters, (view: UserView) =>
      tableSettings.userViewService.add(view, false),
    );
  }

  defineExpose({ open });
</script>
